export default {
  methods: {
    //設定每個外層的em環境(defalt水平的)
    calcEmFontsizeBase: function () {
      this.textInfo.forEach((item) => {
        let emContainer = document.querySelector(`.${item.name}`);
        let textContainer = document.querySelector(
          `.${item.name} .textContainer`
        );
        let emFontsize = textContainer.offsetWidth / item.textLimit;
        emContainer.style.fontSize = emFontsize + "px";
        emContainer.style.lineHeight = 1;
        item.emFontsize = emFontsize;
        item.changeFontsizeLimit = textContainer.offsetWidth / item.maxFontsize;
      });
      this.calcSize();
    },
    //設定每個外層的em環境(垂直的)
    verticalCalcEmFontsizeBase: function () {
      this.verticalTextInfo.forEach((item) => {
        let emContainer = document.querySelector(`.${item.name}`);
        let textContainer = document.querySelector(
          `.${item.name} .textContainer`
        );
        let emFontsize = textContainer.offsetHeight / item.textLimit;
        emContainer.style.fontSize = emFontsize + "px";
        emContainer.style.lineHeight = emFontsize + "px";
        item.emFontsize = emFontsize;
        item.changeFontsizeLimit =
          textContainer.offsetHeight / item.maxFontsize;
      });
      this.verticalCalcSize();
    },
    //設定父層寬高
    calcSize: function () {
      this.textInfo.forEach((item) => {
        let textContainer = document.querySelector(
          `.${item.name} .textContainer`
        );
        textContainer.style.width = item.textLimit + "em";
      });
      this.setMaxFontsize();
    },
    verticalCalcSize: function () {
      // this.verticalTextInfo.forEach(item => {
      //   let textContainer = document.querySelector(
      //     `.${item.name} .textContainer`
      //   );
      //   // textContainer.style.width = item.lineLimit + "em";
      // });
      this.verticalSetMaxFontsize();
    },
    //起初的fontSize
    setMaxFontsize: function () {
      this.textInfo.forEach((item) => {
        let text = document.querySelector(`.${item.name} .textContainer .text`);
        text.style.fontSize = item.maxFontsize / item.emFontsize + "em";
      });
    },
    verticalSetMaxFontsize: function () {
      this.verticalTextInfo.forEach((item) => {
        let text = document.querySelector(`.${item.name} .textContainer .text`);
        text.style.fontSize = item.maxFontsize / item.emFontsize + "em";
      });
    },
    //文字換行
    controlWrap: function (index, textContent) {
      let textLimit = this.textInfo[index].textLimit;
      // let changeFontsizeLimit = this.textInfo[index].changeFontsizeLimit;
      if (textContent.length > textLimit) {
        this.textInfo[index].textContent =
          textContent.substr(0, textLimit).split("").reverse().join("") +
          "</br>" +
          textContent
            .substr(textLimit, textContent.length)
            .split("")
            .reverse()
            .join("");
      } else {
        this.textInfo[index].textContent = textContent
          .split("")
          .reverse()
          .join("");
      }
    },
    controlWrapNotReverse: function (index, textContent) {
      let textLimit = this.textInfo[index].textLimit;
      // let changeFontsizeLimit = this.textInfo[index].changeFontsizeLimit;
      if (textContent.length > textLimit) {
        this.textInfo[index].textContent =
          textContent.substr(0, textLimit).split("").join("") +
          "</br>" +
          textContent.substr(textLimit, textContent.length).split("").join("");
      } else {
        this.textInfo[index].textContent = textContent.split("").join("");
      }
    },
    verticalControlWrap: function (index, textContent) {
      let textLimit = this.verticalTextInfo[index].textLimit;
      // let changeFontsizeLimit = this.verticalTextInfo[index]
      //   .changeFontsizeLimit;
      if (textContent.length > textLimit) {
        this.verticalTextInfo[index].textContent =
          textContent.substr(0, textLimit) +
          "</br>" +
          textContent.substr(textLimit, textContent.length);
      } else {
        this.verticalTextInfo[index].textContent = textContent;
      }
    },
    //縮小fontsize
    controlFontsize: function (index, textContent) {
      // let textLimit = this.textInfo[index].textLimit;
      let changeFontsizeLimit = this.textInfo[index].changeFontsizeLimit;
      //fontSize以及父層的高到第二行之後也是要換高度了
      let text = document.querySelector(
        `.${this.textInfo[index].name} .textContainer .text`
      );
      // let textContainer = document.querySelector(
      //   `.${this.textInfo[index].name} .textContainer`
      // );
      if (textContent.length > changeFontsizeLimit) {
        if (textContent.length <= this.textInfo[index].textLimit) {
          text.style.fontSize =
            this.textInfo[index].textLimit / textContent.length + "em";
        } else if (textContent.length > this.textInfo[index].textLimit) {
          text.style.fontSize =
            this.textInfo[index].textLimit / this.textInfo[index].textLimit +
            "em";
        }
      } else {
        text.style.fontSize =
          this.textInfo[index].maxFontsize / this.textInfo[index].emFontsize +
          "em";
      }
    },
    verticalControlFontsize: function (index, textContent) {
      // let textLimit = this.verticalTextInfo[index].textLimit;
      let changeFontsizeLimit =
        this.verticalTextInfo[index].changeFontsizeLimit;
      //fontSize以及父層的高到第二行之後也是要換高度了
      let text = document.querySelector(
        `.${this.verticalTextInfo[index].name} .textContainer .text`
      );
      // let textContainer = document.querySelector(
      //   `.${this.verticalTextInfo[index].name} .textContainer`
      // );
      if (textContent.length > changeFontsizeLimit) {
        if (textContent.length <= this.verticalTextInfo[index].textLimit) {
          text.style.fontSize =
            this.verticalTextInfo[index].textLimit / textContent.length + "em";
        } else if (
          textContent.length > this.verticalTextInfo[index].textLimit
        ) {
          text.style.fontSize =
            this.verticalTextInfo[index].textLimit /
              this.verticalTextInfo[index].textLimit +
            "em";
        }
      } else {
        text.style.fontSize =
          this.verticalTextInfo[index].maxFontsize /
            this.verticalTextInfo[index].emFontsize +
          "em";
      }
    },
  },
};
